
import { reactive } from "vue";
import DynamicForm from "@/components/Shared/Dynamicform/DynamicForm.vue";

export default {
  name: "PasswordRequest",
  inheritAttrs: false,
  components: {
    DynamicForm
  },
 setup() {    
    const request = reactive({
      apiLoadMethod: "api/anonymousForm/loadForm",
      apiSaveMethod: "",
      form: "PasswortVergessen",
      page: "PasswortVergessen",
      remoteId: "",
      waitForResponse: true
      
    });  
    return {
      request,
    };
  }
};
